import React, { ComponentProps } from 'react'

import { SvgIcon } from '@surglogs-app/icons'
import type { Spacings } from '@surglogs-app/ui.theme'

import {
  TypographyColorVariant,
  getColorKeyFromColorVariant,
} from '../services/TypographyService'

import { Box } from './Box'

interface IconProps extends ComponentProps<typeof Box> {
  icon: SvgIcon
  variant?: TypographyColorVariant
  size?: Spacings
}

export const Icon = ({
  icon: IconComponent,
  display = 'inline-block',
  fsh = 0,
  variant = 'navy.100',
  size = 'lg',
  color,
  ...rest
}: IconProps) => {
  return (
    <Box
      {...{
        display,
        color: color ?? getColorKeyFromColorVariant(variant),
        w: size,
        h: size,
        fsh,
        ...rest,
      }}>
      <IconComponent />
    </Box>
  )
}
